export const UPGRADE_TRANSLATION_KEYS = {
  power: "looks.upgrades.power",
  amount: "looks.upgrades.amount",
  area: "looks.upgrades.area",
  cooldown: "looks.upgrades.cooldown",
  speed: "looks.upgrades.speed",
  duration: "looks.upgrades.duration",
  maxHp: "looks.upgrades.maxHp",
  moveSpeed: "looks.upgrades.moveSpeed",
  luck: "looks.upgrades.luck",
  magnet: "looks.upgrades.magnet",
} as const;

export const WEEKLY_UPGRADE_TRANSLATION_KEYS = {
  power: "looks.weeklyUpgrades.power",
  amount: "looks.weeklyUpgrades.amount",
  area: "looks.weeklyUpgrades.area",
  cooldown: "looks.weeklyUpgrades.cooldown",
  speed: "looks.weeklyUpgrades.speed",
  duration: "looks.weeklyUpgrades.duration",
  maxHp: "looks.weeklyUpgrades.maxHp",
  moveSpeed: "looks.weeklyUpgrades.moveSpeed",
  luck: "looks.weeklyUpgrades.luck",
  magnet: "looks.weeklyUpgrades.magnet",
} as const;

export type UpgradeKey = keyof typeof UPGRADE_TRANSLATION_KEYS;
